export interface IdentifiedSdkExtension {
  readonly id: string;
}

export interface CreatePixatwinSdkExtensionRegistryOptions {
  canRegister(): boolean;
  extensionType: string;
}

export interface PixatwinSdkExtensionRegistry<T extends IdentifiedSdkExtension> {
  register(extension: T): void;
  list(): readonly T[];
}

export const createPixatwinSdkExtensionRegistry = <
  T extends IdentifiedSdkExtension,
>({
  canRegister,
  extensionType,
}: CreatePixatwinSdkExtensionRegistryOptions): PixatwinSdkExtensionRegistry<T> => {
  const extensions = new Map<string, T>();

  return {
    register(extension) {
      if (!canRegister()) {
        throw new Error(
          `Les extensions SDK de type \"${extensionType}\" doivent être enregistrées avant le démarrage du SDK.`,
        );
      }

      if (extensions.has(extension.id)) {
        throw new Error(
          `L'extension SDK \"${extension.id}\" est déjà enregistrée.`,
        );
      }

      extensions.set(extension.id, extension);
    },
    list() {
      return Array.from(extensions.values());
    },
  };
};
